var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "2.3814mm",
    height: "3.0427mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 238.14 304.27",
    preserveAspectRatio: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsxodm: "http://www.corel.com/coreldraw/odm/2003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1_0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--color6)",
    d: "M119.06 304.27c0.1,0 0.23,0 0.34,0 2.71,-0.07 5.39,-0.85 7.24,-2.35l109.31 -66.66c3.39,-2.72 2.76,-33.18 -1.41,-35.4 -4.16,-2.21 -36.75,-1.8 -40.13,0.92l-75.35 60.61 -75.33 -60.61c-3.38,-2.72 -35.97,-3.13 -40.13,-0.92 -4.17,2.22 -4.8,32.68 -1.41,35.4l109.31 66.66c1.85,1.48 4.51,2.28 7.22,2.35 0.08,0 0.23,0 0.34,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color6)",
    d: "M119.07 158.75c-14.61,0 -26.46,11.85 -26.46,26.46 0,14.6 11.85,26.46 26.46,26.46 14.6,0 26.46,-11.86 26.46,-26.46 0,-14.61 -11.82,-26.46 -26.46,-26.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color6)",
    d: "M119.07 79.37c-14.61,0 -26.46,11.86 -26.46,26.46 0,14.61 11.85,26.46 26.46,26.46 14.6,0 26.46,-11.85 26.46,-26.46 0,-14.6 -11.82,-26.46 -26.46,-26.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color6)",
    d: "M119.07 0c-14.61,0 -26.46,11.85 -26.46,26.46 0,14.6 11.85,26.46 26.46,26.46 14.6,0 26.46,-11.86 26.46,-26.46 0,-14.61 -11.82,-26.46 -26.46,-26.46z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.55f4f7a2b5985acce14255ab5cfaa5be.svg";
export { ForwardRef as ReactComponent };